import ContentstackLivePreviewHOC from "./contentstack-live-preview-HOC";
import "./styles.css";

export const ContentstackLivePreview = ContentstackLivePreviewHOC;

export default ContentstackLivePreview;
module.exports = ContentstackLivePreview;
